export const configModal = (app: IModule) => {
    app.config(['$qProvider', function ($qProvider) {
        // Tắt hoàn toàn cảnh báo "Possibly unhandled rejection"
        $qProvider.errorOnUnhandledRejections(false);
    }]);
}
